import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseIcon, Typography } from '@la/ds-ui-components';
import * as S from './Alert.styles';
const Alert = ({ icon, message, onClose }) => {
    return (_jsxs(S.AlertContainer, { children: [icon, _jsx(Typography, Object.assign({ variant: "ui", size: "large" }, { children: message })), onClose ? (_jsx(S.CloseIconContainer, Object.assign({ onClick: onClose }, { children: _jsx(CloseIcon, { size: "medium", fill: "var(--blue-grey-900)" }) }))) : null] }));
};
export { Alert };
